import { render, staticRenderFns } from "./PanelOrganizer.vue?vue&type=template&id=71318afe&scoped=true&"
import script from "./PanelOrganizer.vue?vue&type=script&lang=js&"
export * from "./PanelOrganizer.vue?vue&type=script&lang=js&"
import style0 from "./PanelOrganizer.vue?vue&type=style&index=0&id=71318afe&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71318afe",
  null
  
)

export default component.exports